import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CeroTable from "../../../../components/CeroTable";
import useStyles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { companyFacilityDetails } from "../../../../redux/actions";
import DashboardLayout from "../../../../layouts/DashboardLayout";
import { Container, Link, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { STATUS } from "../../../../redux/constants";
import { setCookie } from "../../../../services/cookie";

export const TableColumns = [
  {
    columnKey: "facility_name",
    columnId: "facility_name",
    columnHeader: "Facility Name",
    width: "25vw",
  },
  {
    columnKey: "address",
    columnId: "address",
    columnHeader: "Address",
    width: "25vw",
  },
  {
    columnKey: "phone_number",
    columnId: "phone_number",
    columnHeader: "Phone Number",
    width: "25vw",
  },
  {
    columnKey: "total_users",
    columnId: "total_users",
    columnHeader: "Total Users",
    width: "15vw",
  },
];

const CompanyFacilityDetailsTable = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { companyId, countryName } = useParams();
  const { onLoadMore } = props;
  const facilityDetails = useSelector(
    (state) => state.listings.facilityDetails.data
  );
  const detailsStatus = useSelector(
    (state) => state.listings.facilityDetails.status
  );

  useEffect(() => {
    dispatch(companyFacilityDetails(companyId, countryName));
  }, [dispatch, companyId, countryName]);

  const onSelectUser = (row) => {
    setCookie("facility_name", row.facility_name);
    navigate(
      `/companies/${companyId}/country/${countryName}/facilities/${row.id}`
    );
  };

  const getFacilityDetails = () =>
    facilityDetails.map((item) => ({
      ...item,
      company: item.company ? item.company : "-",
      facility_name: item.facility_name ? item.facility_name : "-",
      address: item.address ? item.address : "-",
      phone_number: item.phone_number ? item.phone_number : "-",
      total_users: item.total_users ? (
        <Link
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSelectUser(item);
          }}
        >
          {item.total_users}
        </Link>
      ) : (
        "-"
      ),
    }));

  return (
    <DashboardLayout>
      <div
        className={classes.backContainer}
        onClick={() => {
          navigate(-1);
        }}
      >
        <ArrowBackIosIcon />
        Back
      </div>
      <Container className={classes.container}>
        <Typography variant="h6">{countryName}</Typography>
        {detailsStatus === STATUS.SUCCESS && (
          <CeroTable
            columns={TableColumns}
            data={getFacilityDetails()}
            hasMore={false}
            loading={false}
            loadMore={onLoadMore}
            classes={{ tableContainer: classes.tableContainer }}
          />
        )}
      </Container>
    </DashboardLayout>
  );
};

export default CompanyFacilityDetailsTable;
